export default {
      id: "engage-usage",
      viewBox: "0 0 76 75",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#engage",
      toString: function () {
        return this.url;
      }
    }